// extracted by mini-css-extract-plugin
export default {"Popup__container":"Popup_Popup__container__OfMJT","Popup__MenuItem":"Popup_Popup__MenuItem__x++s0"};